import { render, staticRenderFns } from "./CommaInput.vue?vue&type=template&id=5c98bbe0&scoped=true"
import script from "./CommaInput.vue?vue&type=script&lang=js"
export * from "./CommaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98bbe0",
  null
  
)

export default component.exports